@if ((instagramFollowersCountModels$ | async)?.length != 0) {
  @for (instagramFollowersCountModel of instagramFollowersCountModels$ | async; track instagramFollowersCountModel) {
    @if (instagramFollowersCountModel.source !== null) {
      @if (instagramFollowersCountModel.url === null || url == instagramFollowersCountModel.url) {
        <app-aggregated-amount-item
          name="{{ (selectedArtist$ | async)?.nameMain }}"
          account="（ {{
            instagramFollowersCountModel.userName == null
              ? instagramFollowersCountModel.objectId
              : instagramFollowersCountModel.userName
          }}  ）"
          icon="./assets/instagram.png"
          [amount]="instagramFollowersCountModel.units"
          unit="フォロワー数"
          [rate]="instagramFollowersCountModel.rate"
          [link]="instagramFollowersCountModel.url"
          [hasAmount]="instagramFollowersCountModel.hasUnits"
          [loading]="loading$ | async"
          help="{{
            instagramFollowersCountModel.source === 'shareablee' ? 'Shareablee' : 'Chartmetric'
          }}に登録された {{
            !instagramFollowersCountModel.url ? 'Instagram' : instagramFollowersCountModel.url
          }} のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
          [dataCollections]="dataCollections$ | async"
          [dataCollectLoading]="dataCollectLoading$ | async"
          [isDecimal]="true"
          >
        </app-aggregated-amount-item>
      }
    } @else {
      <app-aggregated-amount-item
        name="{{ (selectedArtist$ | async)?.nameMain }}"
        icon="./assets/instagram.png"
        [amount]=""
        unit="フォロワー数"
        [rate]=""
        [link]=""
        [hasAmount]="false"
        [loading]="loading$ | async"
        help="Instagram のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
        [dataCollections]="dataCollections$ | async"
        [dataCollectLoading]="dataCollectLoading$ | async"
        ></app-aggregated-amount-item
        >
      }
    }
  } @else {
    <app-aggregated-amount-item
      name="{{ (selectedArtist$ | async)?.nameMain }}"
      icon="./assets/instagram.png"
      [amount]=""
      unit="フォロワー数"
      [rate]=""
      [link]=""
      [hasAmount]="false"
      [loading]="loading$ | async"
      help="Instagram のフォロワー数です。選択期間内に取得できた最新の値を表示しています。"
      [dataCollections]="dataCollections$ | async"
      [dataCollectLoading]="dataCollectLoading$ | async"
      ></app-aggregated-amount-item
      >
    }

